/**
 * @generated SignedSource<<076cfa7ac35447dbf301e5acf98a9baf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespAuctionMosaicCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespAuctionItemTile_user">;
  readonly " $fragmentType": "SharedRespAuctionMosaicCarousel_user";
};
export type SharedRespAuctionMosaicCarousel_user$key = {
  readonly " $data"?: SharedRespAuctionMosaicCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespAuctionMosaicCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespAuctionMosaicCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespAuctionItemTile_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "34a098773cf082e395279590f12c37d0";

export default node;
